<template>
  <page-header :breadcrum-routes="routes" title="Alta individual">
    <template #tags>
      <tags
        :stateId="
          files.some((f) => f.options.requestCounter > 0)
            ? 9
            : ticket.idLastState
        "
        v-if="ticket.idLastState !== ''"
      />
      <tags type="ticket" :stateId="1" v-else />
      <tags color="processing">ID: {{ ticket.idTicket }}</tags>
    </template>

    <template v-if="userRole != 'rrhh'" #buttons>
      <!-- Cancelar ticket -->
      <a-button
        v-if="
          ticket.idLastState == 7 ||
          ticket.idLastState == 8 ||
          ticket.idLastState == 1
        "
        :loading="loadingState"
        @click="openCancelModal"
      >
        Cancelar
      </a-button>

      <!-- Revisar ticket -->
      <a-button
        type="primary"
        v-if="ticket.idLastState == 7"
        @click="openReviewModal"
        :loading="loadingState"
        class="ml-2"
      >
        Revisado
      </a-button>

      <!-- Ejecutar -->
      <a-button
        type="primary"
        v-if="ticket.idLastState == 8"
        @click="openExecuteModal"
        :loading="loadingState"
        class="ml-2"
      >
        Ejecutar
      </a-button>
    </template>

    <template #content-below-title>
      <div
        v-if="ticket.ticketGroupId"
        style="margin-top: 0px; font-size: 14px"
        class="ant-page-header-content"
      >
        <a-button
          type="primary"
          class="mb-0"
          @click="goToTicketGroup(ticket.ticketGroupId)"
        >
          Ticket masivo: #{{ ticket.ticketGroupId }}
        </a-button>
      </div>
    </template>
  </page-header>

  <stepper
    :state="stepperProps.state"
    ticketType="alta"
    :stateDates="stepperProps.dates"
    ref="stepperRef"
  />

  <a-card>
    <a-row :gutter="[16, 16]">
      <a-col :xs="24" :md="12">
        <datos-ticket
          title="Datos ticket"
          :data="ticketDataTable"
          :loadTicket="loadTicket"
        >
          <template
            v-if="
              userRole != 'rrhh' &&
              (stepperProps.state === 'revision_bewell' ||
                stepperProps.state === 'revision_aseguradora')
            "
            #action
          >
            <a-tooltip>
              <template #title>Editar</template>
              <a-button @click="openIncorporationEditModal">
                <template #icon><edit-outlined /></template>
              </a-button>
            </a-tooltip>

            <edit_modal
              :values="incorporationEditObject"
              :ticketId="ticket.idTicket"
              @editedAltaColaborator="() => getTicketData(ticket.idTicket)"
              ref="editModalRef"
              :rentRequired="employeeRentRequired"
            />
          </template>
        </datos-ticket>

        <a-card
          class="mt-3"
          v-if="userRole != 'rrhh'"
          title="Casos asociados"
          bodyStyle="padding: 24px 24px 24px 24px; border: 1px solid #f0f0f0; border-top-width: 0px;"
          :bordered="false"
        >
          <template #extra v-if="enableCreateCases">
            <a-dropdown>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="1" @click="openModalBackground">
                    Antecedentes
                  </a-menu-item>
                  <a-menu-item key="2" @click="openModalReject">
                    Rechazo
                  </a-menu-item>
                </a-menu>
              </template>
              <a-button>
                Crear caso
                <down-outlined />
              </a-button>
            </a-dropdown>
          </template>
          <div v-if="cases.length == 0">
            <a-typography-text>No existen casos</a-typography-text>
          </div>

          <a-row
            type="flex"
            justify="space-between"
            v-for="c in cases"
            :key="c.id"
          >
            <a-col :span="6">
              <a-typography-text>{{ c.state }}</a-typography-text>
            </a-col>
            <a-col>
              <tags :stateId="c.tag" />
            </a-col>
            <a-col>
              <a-button type="link" @click="redirectCase(c)">
                Ir a caso
              </a-button>
            </a-col>
            <a-divider class="my-2" v-if="cases.length > 1" />
          </a-row>
        </a-card>

        <message-to-insurance
          v-if="insuranceMessage != null && userRole !== 'rrhh'"
          class="mt-3"
          :message="insuranceMessage"
        />

        <comments
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :idToTicket="ticket.idTicket"
          :comments="comments"
          @new_comment="getNewCommment"
        />
      </a-col>
      <a-col :xs="24" :md="12" :style="{ zIndex: 0 }">
        <a-card
          v-if="userRole === 'rrhh'"
          title="Casos asociados"
          bodyStyle="padding: 24px 24px 24px 24px; border: 1px solid #f0f0f0; border-top-width: 0px;"
          :bordered="false"
        >
          <template #extra v-if="enableCreateCases">
            <a-dropdown>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="1" @click="openModalBackground">
                    Antecedentes
                  </a-menu-item>
                  <a-menu-item key="2" @click="openModalReject">
                    Rechazo
                  </a-menu-item>
                </a-menu>
              </template>
              <a-button>
                Crear caso
                <down-outlined />
              </a-button>
            </a-dropdown>
          </template>
          <div v-if="cases.length == 0">
            <a-typography-text>No existen casos</a-typography-text>
          </div>

          <a-row
            type="flex"
            justify="space-between"
            v-for="c in cases"
            :key="c.id"
          >
            <a-col :span="6">
              <a-typography-text>{{ c.state }}</a-typography-text>
            </a-col>
            <a-col>
              <tags :stateId="c.tag"></tags>
            </a-col>
            <a-col>
              <a-button type="link" @click="redirectCase(c)">
                Ir a caso
              </a-button>
            </a-col>
            <a-divider class="my-2" v-if="cases.length > 1" />
          </a-row>
        </a-card>

        <records
          title="Historial"
          :loadingHistory="loadingHistory"
          :data="orderedRecords"
          v-if="userRole != 'rrhh'"
        />

        <a-table
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :row-selection="rowSelectionForm"
          :selections="true"
          :columns="columnsFiles"
          :data-source="filesTotalData"
          :showHeader="false"
          :pagination="false"
          :key="mykey"
          :loading="loadingFiles"
          :scroll="{ x: 'max-content' }"
        >
          <template #title>Formularios adjuntos</template>
          <template #options="{ text: options }">
            <span style="display: flex">
              <a-tooltip color="#05045D" title="Ver más">
                <a-button type="link" :disabled="options.requestCounter > 0">
                  <eye-outlined
                    @click="() => redirectToFile(options.seeMore)"
                  />
                </a-button>
              </a-tooltip>
              <a-tooltip color="#05045D" title="Resolicitar">
                <a-button
                  type="link"
                  @click="() => openReapplyModal(options.fileId)"
                  :disabled="!options.canRequest"
                >
                  <mail-outlined />
                </a-button>
              </a-tooltip>
              <a-tooltip
                color="#05045D"
                title="Historial"
                @click="() => openAttachedDocumentsHistoryModal(options.fileId)"
              >
                <a-button type="link">
                  <clock-circle-outlined />
                </a-button>
              </a-tooltip>
            </span>
          </template>
        </a-table>

        <selected-coverages-table
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :coverages="ticket.coverages"
          :loading="loadingCoverages"
        />

        <dependants-table class="mt-3" />

        <attached-documents
          v-if="userRole != 'rrhh' && ticketOptionalFiles.length > 0"
          class="mt-3"
          title="Archivos opcionales"
          :data="ticketOptionalFiles"
          :loading="loadingOptionalFiles"
        />
      </a-col>
    </a-row>
  </a-card>

  <!-- Historial de documentos adjuntos -->
  <attached-documents-history ref="attachedDocumentsHistoryRef" />

  <!-- Caso de rechazo modal -->
  <a-modal
    v-model:visible="visibleRejectModal"
    title="Crear caso de rechazo"
    :closable="!rejectLoading"
    :maskClosable="!rejectLoading"
  >
    <a-form layout="vertical">
      <a-form-item label="Mensaje para el cliente">
        <a-textarea
          v-model:value="rejectBody"
          :auto-size="{ minRows: 2, maxRows: 5 }"
        />
      </a-form-item>
      <a-form-item label="Carta de rechazo">
        <a-upload
          :file-list="rejectFile"
          :remove="handleRemoveRechazo"
          :before-upload="beforeUploadReject"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            Subir archivo
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button
        key="back"
        @click="visibleRejectModal = false"
        :disabled="rejectLoading"
      >
        Cancelar
      </a-button>
      <a-button
        key="submit"
        type="primary"
        :disabled="rejectFile.length < 1 || rejectBody.length == 0"
        :loading="rejectLoading"
        @click="sendRejectCase"
      >
        Enviar
      </a-button>
    </template>
  </a-modal>

  <!-- Caso por antecedentes modal -->
  <a-modal
    v-model:visible="visibleBackgroundModal"
    title="Crear caso de antecedentes"
    :closable="!loadingBackground"
    :maskClosable="!loadingBackground"
  >
    <a-form layout="vertical">
      <a-form-item label="Mensaje para el colaborador">
        <a-textarea
          v-model:value="backgroundBody"
          :auto-size="{ minRows: 2, maxRows: 5 }"
          placeholder="Escribe aquí el mensaje que quieres enviarle al colaborador, puede ser un resumen de la carta de solicitud de antecedentes..."
        />
      </a-form-item>
      <a-form-item label="Carta de antecedentes">
        <a-upload
          :file-list="backgroundFile"
          :remove="handleRemoveBackground"
          :before-upload="beforeUploadBackground"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            Subir archivo
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button
        key="back"
        @click="visibleBackgroundModal = false"
        :disabled="loadingBackground"
      >
        Cancelar
      </a-button>
      <a-button
        key="submit"
        type="primary"
        :disabled="backgroundFile.length < 1 || backgroundBody.length == 0"
        @click="sendBackgroundCase"
        :loading="loadingBackground"
      >
        Enviar
      </a-button>
    </template>
  </a-modal>

  <!-- Modal Success -->
  <a-modal
    v-model:visible="showSucess"
    centered
    footer=""
    :title="successTitle"
  >
    <a-result status="success" :title="successMessage"></a-result>
  </a-modal>

  <!-- Modal Error -->
  <a-modal v-model:visible="showError" centered footer="" :title="errorTitle">
    <a-result status="error" :title="errorMessage"></a-result>
  </a-modal>

  <!-- Resolicitud de documento -->
  <a-modal
    v-model:visible="showReapplyDoc"
    centered
    @cancel="closeReapplyModal"
    title="Resolicitud de documento"
    :closable="!loadingReapply"
    :maskClosable="!loadingReapply"
  >
    <h3><b>Escribe un mensaje para el colaborador</b></h3>
    <p>
      Recordatorio Nombre:
      {{ ticketDataTable.find((o) => o.key === 'Nombre completo').value }}
    </p>

    <a-textarea
      v-model:value="reapplyText"
      placeholder="Escribe aquí el mensaje para el colaborador"
      :autoSize="{ minRows: 5, maxRows: 5 }"
    />

    <template #footer>
      <a-button
        key="back"
        @click="closeReapplyModal"
        :disabled="loadingReapply"
      >
        Cancelar
      </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loadingReapply"
        :disabled="reapplyButtonBlocked"
        @click="documentReapply(idReapplyDocument)"
      >
        Enviar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import {
  DownOutlined,
  UploadOutlined,
  EditOutlined,
  EyeOutlined,
  MailOutlined,
  ClockCircleOutlined
} from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import { reactive, ref, computed, watchEffect, onMounted } from 'vue';
import { useStore } from 'vuex';
import { createVNode } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import moment from 'moment';
import DependantsTable from '@/new-components/ticket/incorporation/dependants-table.vue';
import SelectedCoveragesTable from '@/new-components/ticket/incorporation/selected-coverages-table.vue';
import AttachedDocumentsHistory from '@/components/attached-documents-history.vue';
import AttachedDocuments from '@/components/tickets/attached-documents.vue';
import {
  FETCH_TICKET,
  FETCH_TICKET_DEPENDANTS,
  FETCH_TICKET_AVAILABLE_COVERAGES,
  FETCH_COVERAGE_POLICY,
  FETCH_COVERAGE_INCORPORATIONS,
  GET_LOGGED_USER,
  FETCH_TICKET_ID,
  FETCH_EMPLOYEE_TICKET,
  FETCH_TICKET_COMMENTS_ID,
  FETCH_FILE_BY_TICKET,
  PUT_REAPPLY_FILE,
  FETCH_CASES,
  POST_REJECT_CASE,
  FETCH_INSURANCES_COMPANY_ID,
  POST_FINISH_INDIVIDUAL_INCORPORATION,
  POST_FILE_ANTECEDENTES,
  POST_SEND_INFO_TO_INSURANCE_COMPANY,
  FETCH_USER_BY_ID,
  POST_CANCEL_INCORPORATION_TICKET,
  FETCH_TICKET_INCOME,
  FETCH_EMPLOYEE_COMPANY_RENT,
  FETCH_TICKET_OPTIONAL_FILES,
  GET_TICKET_OPTIONAL_FILES
} from '@/store/types';
import rutHelper from '@/utils/Ruts';
import {
  hasPendingBrokerCoverages,
  getSelectedOptionalCoverageIds
} from '@/utils/incorporationDetailGroups';
import DatosTicket from '@/components/tickets/ticket-data.vue';
import Comments from '@/components/tickets/comments.vue';
import AltaEditModal from '@/components/tickets/incorporation-edit-modal.vue';
import Records from '@/components/tickets/records.vue';
import parseDate from '@/utils/dateFormatter';
import { useTicketStepper } from '@/composables/use-ticket-stepper';
import getTagColor from '@/utils/getTagColor';
import PageHeader from '@/components/page-header.vue';
import Tags from '@/components/tags.vue';
import notification from '@/utils/notifications';
import Stepper from '@/components/tickets/stepper.vue';
import MensajeAseguradora from '@/components/tickets/insurer-message.vue';
export default {
  name: 'DetalleTicketAltaIndividual',
  components: {
    Stepper,
    'datos-ticket': DatosTicket,
    'down-outlined': DownOutlined,
    comments: Comments,
    records: Records,
    UploadOutlined,
    'page-header': PageHeader,
    tags: Tags,
    EditOutlined,
    edit_modal: AltaEditModal,
    'eye-outlined': EyeOutlined,
    'mail-outlined': MailOutlined,
    'clock-circle-outlined': ClockCircleOutlined,
    'attached-documents-history': AttachedDocumentsHistory,
    'dependants-table': DependantsTable,
    'selected-coverages-table': SelectedCoveragesTable,
    'attached-documents': AttachedDocuments,
    'message-to-insurance': MensajeAseguradora
  },
  setup() {
    // * Router, Vuex, y otras variables de vue
    const route = useRoute();
    const store = useStore();
    const router = useRouter();

    const goToTicketGroup = (id) => {
      router.push({
        name: 'AltaMasivaDetail',
        params: { id }
      });
    };
    const loadingFiles = ref(false);
    const loadingCoverages = ref(false);
    const loadingHistory = ref(false);
    const loadTicket = ref(false);
    const employeeRentRequired = ref(false);
    const incomeAmount = ref();
    // rol de  usuario
    const userRole = store.getters[GET_LOGGED_USER].roleName;

    // * Id del ticket
    const incorporationId = route.params.id;

    // * Page Header
    // Rutas
    const routes = ref([
      {
        path: '/altas',
        breadcrumbName: 'Altas'
      },
      {
        path: '#',
        breadcrumbName: 'Individual'
      },
      {
        breadcrumbName: `#${incorporationId}`
      }
    ]);

    const getBroker = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };

    // * Colores por estado
    const getColorByState = (value) => {
      return getTagColor(value);
    };

    // * Obtencion de data del ticket
    // Ticket data
    const employeeData = reactive({
      name: '',
      rut: ''
    });

    const insuranceMessage = ref('');

    const ticket = reactive({
      idTicket: '',
      ticketGroupId: null,
      employeeId: '',
      typeTicket: '',
      lastState: '',
      idLastState: '',
      createdAt: '',
      startDate: '',
      policies: '',
      message: '',
      digitalForm: {},
      employee: {
        id: '',
        employeeFullName: '',
        employeeName: '',
        employeeSecondName: '',
        employeeSurname: '',
        employeeSecondSurname: '',
        employeeRut: '',
        employeeMail: '',
        employeeCompany: '',
        employeeBirthdayDate: ''
      },
      company: {
        id: '',
        name: ''
      },
      broker: {
        id: '',
        name: ''
      },
      insuranceCompany: {
        id: '',
        name: ''
      },
      coverages: []
    });

    // Comentarios data
    const comments = ref([]);

    const getTicketData = async (id) => {
      loadTicket.value = true;
      try {
        // Data del ticket
        const responseTicket = await store
          .dispatch(FETCH_TICKET_ID, id)
          .catch(() => {
            router.push({ name: 'Missing' });
          });

        if (!responseTicket?.data) {
          loadTicket.value = false;
          return;
        }

        const ticketData = responseTicket.data;
        if (ticketData.type.id != 1) {
          return router.push({ name: 'Missing' });
        }
        ticket.message = ticketData.message;
        insuranceMessage.value = ticketData.message;
        ticket.digitalForm = ticketData.digitalForm;
        ticket.idTicket = ticketData.id;
        ticket.employeeId = ticketData.employee.id;
        ticket.ticketGroupId = ticketData.ticketGroupId;
        const companyId = ticketData.company.id;

        getEmployeeIncome(ticket.employeeId, companyId);

        ticket.typeTicket = ticketData.type.tag;
        ticket.lastState = ticketData.states.sort((a, b) => {
          return b.id - a.id;
        })[0].state.tag;

        ticket.idLastState = ticketData.states.sort((a, b) => {
          return b.id - a.id;
        })[0].state.id;

        ticket.createdAt = ticketData.createdAt;
        ticket.startDate = ticketData.startDate;
        ticket.policies = ticketData.policies
          .reduce((acc, item) => {
            return [...acc, item.numberPolicy];
          }, '')
          .toString();
        ticket.typeTicket = ticketData.type.tag;
        ticket.broker.id = ticketData.broker.id;
        ticket.broker.name = ticketData.broker.name;

        // Crear data para el stepper
        changeStepperData(id, ticketData);

        // Datos del emnpleado
        const response_details = await store
          .dispatch(FETCH_EMPLOYEE_TICKET, id)
          .catch((e) => e.response);
        const employee_data = response_details.data;

        employeeData.name = `${employee_data.employee.firstName} ${employee_data.employee.firstSurname}`;
        employeeData.rut = employee_data.employee.rut;
        ticket.employee.id = employee_data.employee.id;
        ticket.employee.employeeFullName = employee_data.employee.fullname;
        ticket.employee.employeeName = employee_data.employee.firstName;
        ticket.employee.employeeSecondName = employee_data.employee.secondName;
        ticket.employee.employeeSurname = employee_data.employee.firstSurname;
        ticket.employee.employeeSecondSurname =
          employee_data.employee.secondSurname;
        ticket.employee.employeeBirthdayDate =
          employee_data.employee.birthdayDate;
        ticket.employee.employeeRut = employee_data.employee.rut;
        ticket.employee.employeeMail = employee_data.employee.email;
        ticket.employee.employeeCompany = employee_data.company.businessName;

        ticket.company.id = ticketData.groupCompanies.map((gc) => gc.id);
        ticket.company.name = ticketData.groupCompanies
          .map((gc) => gc.name)
          .join(', ');

        // Aseguradora que pertenece el ticket
        const insuranceResponse = await store.dispatch(
          FETCH_INSURANCES_COMPANY_ID,
          ticketData.insuranceCompanyId
        );

        loadTicket.value = false;

        ticket.insuranceCompany.id = insuranceResponse.data.id;
        ticket.insuranceCompany.name = insuranceResponse.data.businessName;

        // Documentos
        await getDocumentsByTicketId(id);
        // Coberturas
        await getCoversByCompanyId(id);

        // Casos
        await getAllCasesByTicketId(id);

        // Comentarios
        await getCommentsByTicketId(id);
      } catch (err) {
        loadTicket.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          err.response?.data ? err.response.data.message : 'error'
        );
        console.error('Ocurrió un error, vuelve a intentarlo más tarde', err);
      }
    };

    const ticketOptionalFiles = ref([]);
    const loadingOptionalFiles = ref(false);

    const getTicketOptionalFiles = async () => {
      loadingOptionalFiles.value = true;
      try {
        if (userRole != 'rrhh') {
          await store.dispatch(FETCH_TICKET_OPTIONAL_FILES, incorporationId);
        }
        ticketOptionalFiles.value =
          await store.getters[GET_TICKET_OPTIONAL_FILES];
        loadingOptionalFiles.value = false;
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al cargar archivos opcionales del Ticket ${incorporationId}. ${error}`
        );
        loadingOptionalFiles.value = false;
      }
    };

    /* const coverageStateSelection = () => {
      // Este metodo es para poner si se puede seleccionar la cobertura si es que el estado es "Revision bewell"
      if (ticket.lastState.toLowerCase() != 'en revision bewell') {
        return true;
      }
      return false;
    }; */

    /*


    const coverages = ref([]);




    const valueTextArea = ref('');




    */

    /* const createComment = async () => {
      try {
        if (valueTextArea.value != '' || valueTextArea.value == undefined) {
          // Añado una funcion de timeout para hacer parecer que esta cargando
          // Debido a que como estamos trabajando en localhost, la data obviamente carga demasiado rapido
          // Esto da una sensacion de carga
          const comment_to_post = {
            ticket_id: incorporationId,
            comment_data: valueTextArea.value
          };
          route.dispatch(POST_COMMENTS, comment_to_post).then(() => {
            valueTextArea.value = '';
            route.dispatch(FETCH_COMMENTS);
          });
        }
      } catch (error) {

      }
    }; */

    /*
      // TODO: ARREGLAR VARIABLES SIN USO
      // eslint-disable-next-line no-unused-vars
      const state_ticket = await finishIncorporationIndividual({
        ticket_id: incorporationId,
        state_id: 3
      });

      location.reload();
    }; */

    // Llamada de metodos para obtener la data
    /* getTicketData(incorporationId); */

    // * Data para la tabla de detalle del ticker

    const ticketDataTable = computed(() => {
      const values = [
        {
          key: 'Fecha de inicio de vigencia',
          value: moment(ticket.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
        },
        {
          key: 'Nombre completo',
          value: ticket.employee.employeeFullName
        },
        {
          key: 'RUT',
          value: rutHelper.formatRut(ticket.employee.employeeRut)
        }
      ];

      if (employeeRentRequired.value === true) {
        values.push({
          key: 'Renta',
          value:
            incomeAmount.value !== undefined
              ? `$ ${incomeAmount.value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              : incomeAmount.value
        });
      }

      values.push(
        {
          key: 'Fecha de nacimiento',
          value: ticket.employee.employeeBirthdayDate
            ? moment(ticket.employee.employeeBirthdayDate, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )
            : '-'
        },
        {
          key: 'Correo',
          value: ticket.employee.employeeMail
        },
        {
          key: 'Empresa',
          value: ticket.employee.employeeCompany
        },
        {
          key: 'Grupo',
          value: ticket.company.name
        },
        {
          key: 'Aseguradora',
          value: ticket.insuranceCompany.name
        },
        {
          key: 'Póliza',
          value: ticket.policies
        },
        {
          key: 'Broker',
          value: ticket.broker.name
        }
      );

      return values;
    });

    const incorporationEditObject = computed(() => {
      return {
        startDate: ticket.startDate,
        firstName: ticket.employee.employeeName,
        secondName: ticket.employee.employeeSecondName,
        firstSurname: ticket.employee.employeeSurname,
        secondSurname: ticket.employee.employeeSecondSurname,
        birthdayDate: ticket.employee.employeeBirthdayDate,
        rut: ticket.employee.employeeRut,
        email: ticket.employee.employeeMail,
        incomeAmount: incomeAmount.value
      };
    });

    // * Stepper
    const stepperRef = ref('null');
    const reviewIncorporation = ref(false);
    const finishIncorporation = ref(false);
    const executedIncorporation = ref(false);
    const showOnlyCancel = ref(false);
    const enableCreateCases = ref(false);

    const {
      stepperProps,
      recordsSteps,
      lastStateTag,
      ticketStateId,
      rebuild: rebuildStepper
    } = useTicketStepper(null, {
      onCancel: () => stepperRef.value?.cancelStep?.(),
      onFinish: () => stepperRef.value?.finishStep?.()
    });

    const changeStepperData = async (id, ticketDataParam) => {
      // Thin wrapper: fetch the ticket (or reuse a pre-fetched payload)
      // and delegate stepper-state construction to useTicketStepper.
      // The 5x-duplicated stepper-building algorithm + getStateType
      // switch-case now lives in src/composables/use-ticket-stepper.js.
      loadingHistory.value = true;
      try {
        let ticketData;
        if (ticketDataParam) {
          ticketData = ticketDataParam;
        } else {
          const ticketResponse = await store
            .dispatch(FETCH_TICKET_ID, id)
            .catch((e) => e.response);
          ticketData = ticketResponse.data;
        }
        rebuildStepper(ticketData);

        // View-specific state derived from the composable's outputs.
        ticket.idLastState = ticketStateId.value;
        ticket.lastState = lastStateTag.value;

        const step = stepperProps.state;
        const last = lastStateTag.value;
        reviewIncorporation.value = step === 'revision_bewell';
        finishIncorporation.value = step === 'revision_aseguradora';
        executedIncorporation.value =
          last === 'Cancelado' || last === 'Ejecutado';
        showOnlyCancel.value = last === 'Creado';
        enableCreateCases.value = false;

        if (last === 'Cancelado') {
          reviewIncorporation.value = false;
          finishIncorporation.value = false;
          showOnlyCancel.value = false;
        } else if (last === 'En aseguradora') {
          enableCreateCases.value = userRole != 'rrhh';
        }
        loadingHistory.value = false;
      } catch (error) {
        loadingHistory.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          error.response.data ? error.response.data.message : 'error'
        );
        console.error('error', error);
      }
    };

    // * Formatear fecha

    const classFinish = ref('');
    // * Comentarios
    const getCommentsByTicketId = async (id) => {
      const responseComments = await store
        .dispatch(FETCH_TICKET_COMMENTS_ID, id)
        .catch((e) => e.response);

      for (let i = 0; i < responseComments.data.length; i++) {
        const element = responseComments.data[i];
        const brokerName = await getBroker(responseComments.data[i].brokerId);
        comments.value.push({
          description: parseDate(element.createdAt),
          title: element.message,
          author: brokerName
        });

        recordsComments.push({
          description: element.createdAt,
          title: 'Nuevo comentario'
        });
      }
    };

    const getNewCommment = async (value) => {
      const { description } = value;
      const { brokerId } = value;
      const brokerName = await getBroker(brokerId);

      comments.value.push({
        title: value.title,
        description: parseDate(description),
        author: brokerName
      });

      recordsComments.push({
        description,
        title: 'Nuevo comentario'
      });
    };

    // * Historial

    const recordsComments = reactive([]);
    const recordsFiles = reactive([]);

    const orderedRecords = computed(() => {
      const rows = [];
      const records = [recordsSteps, recordsComments, recordsFiles];

      records.forEach((element) => {
        for (let i = 0; i < element.length; i++) {
          const el = element[i];
          if (el.title == 'Ejecutado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'finish'
            });
          } else if (el.title == 'Cancelado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'error'
            });
          } else {
            rows.push({
              description: new Date(el.description),
              title: el.title
            });
          }
        }
      });

      rows.sort(function (a, b) {
        return a.description - b.description;
      });

      for (let i = 0; i < rows.length; i++) {
        const element = rows[i];
        const fecha = parseDate(element.description); // formatDate(element.description);
        rows[i].description = fecha;
      }
      return rows;
    });

    // * ### CASOS ###
    // * Obtener todos los casos

    const cases = ref([]);

    const getAllCasesByTicketId = async (id) => {
      cases.value = [];

      const responseCases = await store
        .dispatch(FETCH_CASES, id)
        .catch((e) => e.response);

      for (let i = 0; i < responseCases.data.length; i++) {
        const obj = {
          id: '',
          tag: '',
          state: '',
          typeCaseId: 0
        };

        const caso = responseCases.data[i];

        obj.id = caso.id;
        obj.tag = caso.states
          .sort((a, b) => {
            return b.id - a.id;
          })[0]
          .state.id.toString();
        obj.state = caso.typeCase.tag;
        obj.typeCaseId = caso.typeCaseId;

        cases.value.push(obj);
      }
    };

    const casesSorted = computed(() => {
      return cases.value.reduce((acc, item) => {
        return [...acc, item.state];
      }, []);
    });

    // * Caso de rechazo
    const visibleRejectModal = ref(false); // Abrir y cerrar el modal para crear el caso
    const rejectBody = ref('');
    const rejectFile = ref([]);
    const rejectLoading = ref(false);
    const showSucess = ref(false);
    const successTitle = ref('');
    const successMessage = ref('');
    const showError = ref(false);
    const errorTitle = ref('');
    const errorMessage = ref('');

    const openModalReject = () => {
      // Este metodo abre le modal de rechazo
      visibleRejectModal.value = true;
      rejectBody.value = `Estimado cliente adjuntamos resolución de la compañía aseguradora, de la solicitud de incorporación del colaborador ${employeeData.name} ${employeeData.rut}, informando su rechazo según normativa vigente. Ante cualquier duda, por favor contactar con su ejecutivo comercial.`;
    };

    const sendRejectCase = async () => {
      // Hago el efecto de carga
      rejectLoading.value = true;

      // Enviar el caso de rechazo
      showSucess.value = false;
      const formData = new FormData();
      formData.append('ticketId', ticket.idTicket);
      formData.append('brokerId', store.state.auth.auth.id);
      formData.append('message', rejectBody.value);
      formData.append('file', rejectFile.value[0]);
      formData.append('insuranceCompanyId', ticket.insuranceCompany.id);
      formData.append('name', 'Carta de rechazo');

      try {
        await store.dispatch(POST_REJECT_CASE, formData);

        rejectBody.value = '';
        rejectFile.value = [];

        getAllCasesByTicketId(incorporationId);
        changeStepperData(incorporationId);

        // Enviar un mensaje de correcto
        openNotificationWithIcon(
          'success',
          'Correcto',
          'Caso de rechazo enviado correctamente'
        );

        showSucess.value = true;
        successTitle.value = 'Creación de caso de rechazo';
        successMessage.value = 'Mensaje enviado';
      } catch (error) {
        const { message } = error.response.data
          ? error.response.data.message
          : 'error';

        // Enviar mensaje de error
        openNotificationWithIcon('error', 'Error', message);

        showError.value = true;
        errorTitle.value = 'Creación de caso de rechazo';
        errorMessage.value = 'No se ha podido generar el caso';
      }

      // Parar el efecto de carga
      rejectLoading.value = false;

      // Cerrar el modal
      visibleRejectModal.value = false;
    };

    const handleRemoveRechazo = (file) => {
      // Eliminar el archivo subido al modal
      const index = rejectFile.value.indexOf(file);
      const newFileList = rejectFile.value.slice();
      newFileList.splice(index, 1);
      rejectFile.value = newFileList;
    };

    const beforeUploadReject = (file) => {
      // Antes de que se suba, dejarlo en false para que no se suba automaticamente.
      // Tener en cuenta que se puede subir solo un archivo, asi que si se sube uno nuevo, reemplazarlo por el que ya existe
      rejectFile.value = [file];
      return false;
    };

    // * Casos por antecedentes
    const visibleBackgroundModal = ref(false); // Abrir y cerrar el modal para crear el caso
    const backgroundBody = ref('');
    const backgroundFile = ref([]);
    const loadingBackground = ref(false);

    const openModalBackground = () => {
      // Este metodo abre le modal de rechazo
      visibleBackgroundModal.value = true;
      backgroundBody.value = '';
    };

    const sendBackgroundCase = async () => {
      // Mostrar el boton cargando
      loadingBackground.value = true;

      try {
        const formData = new FormData();
        formData.append('ticketId', incorporationId);
        formData.append('brokerId', store.state.auth.auth.id);
        formData.append('message', backgroundBody.value);
        formData.append('insuranceCompanyId', ticket.insuranceCompany.id);
        formData.append('file', backgroundFile.value[0]);
        formData.append('name', 'Caso por antecedentes');

        // await store.dispatch(POST_FILE_ANTECEDENTES);
        await store.dispatch(POST_FILE_ANTECEDENTES, formData);

        backgroundBody.value = '';
        backgroundFile.value = [];

        getAllCasesByTicketId(incorporationId);
        changeStepperData(incorporationId);

        // Mensaje de correcto
        openNotificationWithIcon(
          'success',
          'Correcto',
          'Caso de antecedentes enviado correctamente'
        );
      } catch (error) {
        console.log(error);
        openNotificationWithIcon(
          'error',
          'Error',
          error.response.data ? error.response.data.message : 'error'
        );
      }

      // Paro el modal cargando
      loadingBackground.value = false;

      // Cerrar el modal
      visibleBackgroundModal.value = false;
    };

    const handleRemoveBackground = (file) => {
      // Eliminar el archivo subido al modal
      const index = backgroundFile.value.indexOf(file);
      const newFileList = backgroundFile.value.slice();
      newFileList.splice(index, 1);
      backgroundFile.value = newFileList;
    };

    const beforeUploadBackground = (file) => {
      // Antes de que se suba, dejarlo en false para que no se suba automaticamente.
      // Tener en cuenta que se puede subir solo un archivo, asi que si se sube uno nuevo, reemplazarlo por el que ya existe

      backgroundFile.value = [file];
      const fileSize = file.size / 1024 / 1024;
      if (backgroundFile.value.length == 1) {
        if (fileSize > 5) {
          openNotificationWithIcon(
            'error',
            'Error',
            'Excede el tamaño maximo de archivo (5mb)'
          );
          handleRemoveBackground(file);
        }
      }

      return false;
    };

    // * Documentos
    const files = ref([]);
    const selectedFiles = ref([]);

    const getDocumentsByTicketId = async (id) => {
      loadingFiles.value = true;
      try {
        // Lo inicializo en 0, ya que cuando cambie de estado el ticket tengo que obtener los archivos otra vez
        // asi que en caso de llamar denuevo a este metodo, obtengo la lista de archivos nuevamente para mostrarlo

        files.value.length = 0;
        recordsFiles.length = 0;

        const responseFiles = await store.dispatch(FETCH_FILE_BY_TICKET, id);

        // Obtengo la data
        for (let i = 0; i < responseFiles.data.length; i++) {
          const element = responseFiles.data[i];

          const obj = {
            key: i + 1,
            id: element.id,
            name: element.name,
            company: ticket.insuranceCompany.name,
            status: true,
            options: {
              seeMore: element.ticketFileUrl,
              fileId: element.id,
              // canRequest: element.filePath.includes('dform/signed-pdf') || element.fileInsuranceCompanyId != null,
              canRequest: element.fileInsuranceCompanyId != null,
              requestCounter: element.requestCounter
            }
          };
          files.value.push(obj);
          // Lo guardo tambien en el historial
          recordsFiles.push({
            description: element.createdAt,
            title: 'Documento enviado'
          });
        }
        loadingFiles.value = false;
      } catch (error) {
        loadingFiles.value = false;
        console.error('error', error);
      }
    };

    const filesTotalData = computed(() => {
      if (stepperProps.state === 'creado') {
        return [];
      }
      return files.value;
    });

    // Resolicitud de documentos
    const showReapplyDoc = ref(false);
    const idReapplyDocument = ref();
    const reapplyText = ref(
      'Estimado/a te informamos que recepcionamos tu formulario de incorporación y hemos detectado que se encuentra incompleto en la sección:'
    );
    const loadingReapply = ref(false);

    const openReapplyModal = (id_document) => {
      idReapplyDocument.value = id_document;
      showReapplyDoc.value = true;
    };

    const closeReapplyModal = () => {
      idReapplyDocument.value = 0;
      showReapplyDoc.value = false;
      reapplyText.value =
        'Estimado/a te informamos que recepcionamos tu formulario de incorporación y hemos detectado que se encuentra incompleto en la sección:';
    };

    const documentReapply = async (id_document) => {
      loadingReapply.value = true;
      try {
        // ! Aca debo mandar el mensaje de este => !!!!reapplyText!!!!
        await store.dispatch(PUT_REAPPLY_FILE, {
          id: id_document,
          payload: {
            message: reapplyText.value
          }
        });

        showSucess.value = true;
        successTitle.value = 'Mensaje enviado';
        successMessage.value =
          'Su solicitud de documento ha sido enviada con éxito';
        reapplyText.value = '';
      } catch (error) {
        showError.value = true;
        errorTitle.value = 'Error';
        errorMessage.value = openNotificationWithIcon(
          'error',
          'Error',
          error.response.data
        );
      }
      loadingReapply.value = false;
      closeReapplyModal();
      getDocumentsByTicketId(incorporationId);
    };

    const reapplyButtonBlocked = computed(() => {
      const backupText =
        'Estimado/a te informamos que recepcionamos tu formulario de incorporación y hemos detectado que se encuentra incompleto en la sección:';

      if (reapplyText.value != backupText && reapplyText.value != '') {
        return false;
      }

      return true;
    });

    const columnsFiles = [
      {
        dataIndex: 'name'
      },
      {
        dataIndex: 'company'
      },
      {
        dataIndex: 'options',
        slots: { customRender: 'options' }
      }
    ];

    // * Terminar la seleccion
    const loadingState = ref(false);

    const openReviewModal = () => {
      Modal.confirm({
        title: () => '¿Deseas enviar documentos a compañía aseguradora?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          finishSelection();
        },
        onCancel() {}
      });
    };
    const changeCheckbox = (selectedRowKeys, selectedRows) => {
      selectedFiles.value.length = 0;
      for (let i = 0; i < selectedRows?.length; i++) {
        const element = selectedRows[i];
        selectedFiles.value.push(element);
      }
    };
    const idCheckbox = ref([]);
    const getCheckbox = (record) => {
      if (ticket.idLastState == 8 || ticket.idLastState == 3) {
        idCheckbox.value.push(record.key);
        return {
          disabled: false
        };
      }
      if (
        stepperProps.state == 'revision_aseguradora' &&
        ticket.idLastState == 4
      ) {
        idCheckbox.value.push(record.key);
        return {
          disabled: false
        };
      }
    };

    const rowSelectionForm = computed(() => {
      if (
        ticket.idLastState == 8 ||
        ticket.idLastState == 3 ||
        ticket.idLastState == 4
      ) {
        return {
          onChange: changeCheckbox,
          getCheckboxProps: getCheckbox,
          selectedRowKeys: idCheckbox.value
        };
      }
      return {
        onChange: changeCheckbox,
        getCheckboxProps: getCheckbox
        // selectedRowKeys:0,
      };
    });

    // const getCheckboxProps = () => {
    //   if(finalState.value=='revision_aseguradora'||finalState.value=='ejecutado'){
    //     return ({
    //       disabled:true,
    //     });
    //   }
    // };
    const checkDisabled = ref(true);
    const mykey = ref(0);
    watchEffect(() => {
      if (ticket.idLastState == 8 || ticket.idLastState == 3) {
        mykey.value++;
      }
    });

    const finishSelection = async () => {
      // Dejo cargando el boton
      loadingState.value = true;

      // let files_selected = true;

      const coverSelected = !hasPendingBrokerCoverages(ticket.coverages);

      if (!coverSelected) {
        openNotificationWithIcon(
          'error',
          'Coberturas sin seleccionar',
          'Para avanzar debes seleccionar Si o No en cada cobertura opcional'
        );
        loadingState.value = false;
        return;
      }

      // Comparo que los archivos que se muestran en la seccion "Formularios adjuntos" estén seleccionados
      if (selectedFiles.value.length != files.value.length) {
        // files_selected = true;

        // Hago que se demore 100 milisegundos solo para que aparesca uno despues del otro
        setTimeout(function () {
          openNotificationWithIcon(
            'error',
            'Error',
            'Revise y seleccione los formularios adjuntos'
          );
        }, 100);
        // loadingState.value=false;
      }

      if (coverSelected && selectedFiles.value.length) {
        try {
          // Solo la revision corredora de un ticket PDF sin formulario
          // digital concilia la seleccion Si/No. Los demas flujos mantienen
          // el envio actual con las coberturas ya preparadas.
          const isPdfBrokerReview =
            stepperProps.state === 'revision_bewell' && !ticket.digitalForm?.id;
          await store.dispatch(POST_SEND_INFO_TO_INSURANCE_COMPANY, {
            id: incorporationId,
            ...(isPdfBrokerReview
              ? {
                  selectedCoverageGroupCompanyIds:
                    getSelectedOptionalCoverageIds(ticket.coverages)
                }
              : {})
          });

          await changeStepperData(incorporationId);

          await getCoversByCompanyId(incorporationId);

          await getDocumentsByTicketId(incorporationId);
          openNotificationWithIcon(
            'success',
            'Correcto',
            'La información fue enviada a la aseguradora exitosamente'
          );
        } catch (error) {
          if (error.response.data.message == 'La relacion ya existe') {
            openNotificationWithIcon(
              'error',
              'Error',
              'Ya existen estas coberturas asociadas a este asegurado'
            );
          } else {
            openNotificationWithIcon(
              'error',
              'Error',
              error.response.data ? error.response.data.message : 'error'
            );
          }
        }
      }
      loadingState.value = false;
    };

    const openNotificationWithIcon = (type, title, message) => {
      notification(type, title, message);
    };

    const redirectToFile = (url) => {
      window.open(url, '_blank');
    };

    const attachedDocumentsHistoryRef = ref();
    const openAttachedDocumentsHistoryModal = (id) => {
      attachedDocumentsHistoryRef.value.openModal(id);
    };

    const editModalRef = ref();
    const openIncorporationEditModal = () => {
      editModalRef.value.openModal();
    };

    const openCancelModal = () => {
      Modal.confirm({
        title: () => '¿Estás seguro que deseas cancelar el ticket de alta?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          cancelTicket();
        },
        onCancel() {}
      });
    };

    const cancelTicket = async () => {
      loadingState.value = true;
      try {
        // Hago la request hacia la base de datos
        await store.dispatch(POST_CANCEL_INCORPORATION_TICKET, incorporationId);

        // Actualizo nuevamente el stepper para que se coloque automaticamente
        await changeStepperData(incorporationId);
        await getCoversByCompanyId(route.params.id);

        loadingState.value = false;
      } catch (error) {
        loadingState.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          error.response.data ? error.response.data.message : 'error'
        );
        console.error('error', error);
      }
    };

    // * Ejecutar ticket
    const openExecuteModal = () => {
      Modal.confirm({
        title: () => '¿Estás seguro que deseas ejecutar el ticket?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          execute();
        },
        onCancel() {}
      });
    };

    // TODO: Cambiar en un futuro al endpoint que me va a mandar Lepe
    const execute = async () => {
      loadingState.value = true;
      try {
        // TODO: VER ENDPOINT Y FLUJO
        await store.dispatch(
          POST_FINISH_INDIVIDUAL_INCORPORATION,
          incorporationId
        );
        // await createStateTicket({
        //   ticketId: incorporationId,
        //   stateId: 3
        // });

        await changeStepperData(incorporationId);

        // TODO: Cambiar el estado del empleado a asegurado
        openNotificationWithIcon(
          'success',
          'Correcto',
          'Incorporación ejecutada exitosamente'
        );
        loadingState.value = false;
      } catch (error) {
        loadingState.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          error.response.data ? error.response.data.message : 'error'
        );
        console.error('error', error);
      }
    };

    // * Coberturas
    const getCoversByCompanyId = async (id) => {
      loadingCoverages.value = true;
      ticket.coverages.length = 0;

      const availableCoverages =
        // NOTE: fetches employee/policy-holder coverages (no allowDependents filter).
        // Distinct from the v2 dependants-available-coverages endpoint.
        (await store.dispatch(FETCH_COVERAGE_POLICY, id)).data;

      if (stepperProps.state == 'revision_aseguradora') {
        const stagedCoverages = (
          await store.dispatch(FETCH_COVERAGE_INCORPORATIONS, id)
        ).data;

        for (let j = 0; j < stagedCoverages.length; j += 1) {
          const stagedCoverage = stagedCoverages[j];
          ticket.coverages.push({
            key: j,
            idCoverage: stagedCoverage.id,
            groupName: stagedCoverage.groupCompany?.name,
            nameCoverage: `${stagedCoverage.coverage?.name}`,
            numberPolicy: `${stagedCoverage.policy?.numberPolicy}`,
            required: stagedCoverage.coverage?.required,
            selected: true
          });
        }
      } else if (stepperProps.state == 'ejecutado') {
        const employeeResponse = await store.dispatch(
          FETCH_EMPLOYEE_TICKET,
          id
        );
        const selectedCoverages = employeeResponse.data.employee.coverages;

        for (let j = 0; j < selectedCoverages.length; j += 1) {
          const selectedCoverage = selectedCoverages[j];
          ticket.coverages.push({
            key: j,
            idCoverage: selectedCoverage.coverageGroupCompany?.id,
            groupName:
              selectedCoverage.coverageGroupCompany?.policyGroupCompany
                ?.groupCompanies?.name,
            nameCoverage: `${selectedCoverage.coverageGroupCompany?.coverage?.name}`,
            numberPolicy: `${selectedCoverage.coverageGroupCompany?.policyGroupCompany?.policies?.numberPolicy}`,
            required: selectedCoverage.coverageGroupCompany?.coverage?.required
              ? true
              : '',
            selected: true
          });
        }
      } else if (
        stepperProps.state == 'revision_bewell' &&
        !ticket.digitalForm?.id
      ) {
        for (let j = 0; j < availableCoverages.length; j += 1) {
          const availableCoverage = availableCoverages[j];

          ticket.coverages.push({
            key: j,
            idCoverage: availableCoverage.id,
            groupName: availableCoverage.groupCompany.name,
            nameCoverage: `${availableCoverage.coverage.name}`,
            numberPolicy: `${availableCoverage.policy.numberPolicy}`,
            required: availableCoverage.coverage.required,
            selected: availableCoverage.coverage.required ? true : ''
          });
        }
      } else if (
        stepperProps.state == 'revision_bewell' &&
        ticket.digitalForm?.id
      ) {
        const employeeResponse = await store.dispatch(
          FETCH_EMPLOYEE_TICKET,
          id
        );
        const selectedCoverages = employeeResponse.data.employee.coverages;

        for (let j = 0; j < availableCoverages.length; j += 1) {
          const availableCoverage = availableCoverages[j];
          const selectedCoverage = selectedCoverages.find(
            (s) => availableCoverage.id == s.coverageGroupCompany.id
          );
          const selected =
            selectedCoverage || availableCoverage.coverage.required
              ? true
              : false;

          ticket.coverages.push({
            key: j,
            idCoverage: availableCoverage.id,
            groupName: availableCoverage.groupCompany.name,
            nameCoverage: `${availableCoverage.coverage.name}`,
            numberPolicy: `${availableCoverage.policy.numberPolicy}`,
            required: availableCoverage.coverage.required,
            selected
          });
        }
      }
      loadingCoverages.value = false;
    };
    const redirectCase = (value) => {
      const ticketId = value.id;

      const ticketType =
        value.state === 'Out of Time'
          ? 'fuera_de_tiempo'
          : value.state.toLowerCase();

      switch (ticketType) {
        case 'antecedentes':
          router.push({ name: 'DetalleCaso', params: { id: ticketId } });
          break;
        case 'rechazo':
          router.push({ name: 'DetalleRechazo', params: { id: ticketId } });
          break;
        case 'fuera de tiempo: formulario de incorporación':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
        case 'fuera de tiempo: falta de antecedentes':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
        case 'fuera de tiempo: alta individual':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
        case 'fuera de tiempo: alta individual (broker)':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
        case 'fuera de tiempo: formulario de modificación':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
      }
    };

    const getRentRequirement = () => {
      store
        .dispatch(FETCH_TICKET_INCOME, incorporationId)
        .then((resp) => {
          employeeRentRequired.value = resp.data.isIncomeRequired;
        })
        .catch((error) => {
          notification('error', 'Error', error.response.data.messsage);
        });
    };

    const getEmployeeIncome = (employeeId, companyId) => {
      store
        .dispatch(FETCH_EMPLOYEE_COMPANY_RENT, {
          employeeId: employeeId,
          companyId: companyId
        })
        .then((resp) => {
          if (resp.data != null) {
            incomeAmount.value = resp.data.incomeAmount;
          } else {
            incomeAmount.value = 0;
          }
        })
        .catch((error) => {
          notification('error', 'Error', error.response.data.messsage);
        });
    };

    onMounted(() => {
      store.dispatch(FETCH_TICKET, route.params.id);
      getRentRequirement();
      getTicketData(incorporationId);
      store.dispatch(FETCH_TICKET_DEPENDANTS, route.params.id);
      store.dispatch(FETCH_TICKET_AVAILABLE_COVERAGES, route.params.id);
      getTicketOptionalFiles();
    });

    return {
      // test,
      idCheckbox,
      mykey,
      classFinish,
      routes,
      checkDisabled,
      changeCheckbox,
      getCheckbox,
      employeeData,
      incorporationId,
      finishSelection,
      getColorByState,
      stepperRef,
      stepperProps,
      insuranceMessage,
      ticket,
      ticketDataTable,
      cases,
      casesSorted,
      comments,
      getNewCommment,
      rowSelectionForm,
      columnsFiles,
      files,
      visibleRejectModal,
      rejectBody,
      openModalReject,
      rejectFile,
      sendRejectCase,
      handleRemoveRechazo,
      beforeUploadReject,
      reviewIncorporation,
      visibleBackgroundModal,
      backgroundBody,
      openModalBackground,
      sendBackgroundCase,
      handleRemoveBackground,
      beforeUploadBackground,
      backgroundFile,
      showSucess,
      showError,
      filesTotalData,
      cancelTicket,
      execute,
      enableCreateCases,
      showOnlyCancel,
      executedIncorporation,
      finishIncorporation,
      loadingBackground,
      rejectLoading,
      orderedRecords,
      openCancelModal,
      loadingState,
      openReviewModal,
      openExecuteModal,
      redirectCase,
      documentReapply,
      userRole,
      showReapplyDoc,
      idReapplyDocument,
      reapplyText,
      openReapplyModal,
      closeReapplyModal,
      loadingReapply,
      reapplyButtonBlocked,
      successTitle,
      successMessage,
      errorTitle,
      errorMessage,
      loadingFiles,
      loadingCoverages,
      loadingHistory,
      loadTicket,
      editModalRef,
      openIncorporationEditModal,
      incorporationEditObject,
      getTicketData,
      recordsFiles,
      redirectToFile,
      attachedDocumentsHistoryRef,
      openAttachedDocumentsHistoryModal,
      employeeRentRequired,
      ticketOptionalFiles,
      loadingOptionalFiles,
      getTicketOptionalFiles,
      goToTicketGroup
    };
  }
};
</script>
<style>
ant.upload-list-item-card-actions {
  top: 0;
}
</style>
